// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"90":"bd57829c","952":"70d223dd","966":"2d8a69a2"}[chunkId] + ".css";
};